'use client';

import { useEffect, useState } from 'react';


export default function AboutHero() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -5% 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <section className="pt-20 lg:pt-24 relative overflow-hidden bg-gray-950">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center min-h-[calc(100vh-5rem)]">
          {/* Right: Content */}
          <div className="animate-on-scroll animate-in-delay-2 order-1 lg:order-2">
            <span className="text-xs uppercase tracking-[0.4em] text-blue-400 mb-6 block">
              About E-GREGOR
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Transforming Business Through{' '}
              <span className="text-gradient-blue">Digital Innovation</span>
            </h1>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed mx-8">
              Since 2024, we've been empowering businesses with comprehensive technology solutions that drive growth, efficiency, and innovation.
            </p>
            
            {/* Key highlights */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Expert Team</h3>
                  <p className="text-gray-400 text-sm">Industry-certified professionals with decades of combined experience</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">Cutting-Edge Solutions</h3>
                  <p className="text-gray-400 text-sm">Leveraging the latest technologies to deliver innovative results</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-6 h-6 rounded-full bg-blue-500 flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-1">24/7 Support</h3>
                  <p className="text-gray-400 text-sm">Round-the-clock assistance to keep your business running smoothly</p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="flex flex-wrap gap-4">
              <a
                href="/services"
                className="px-8 py-4 border border-zinc-700 hover:border-blue-500 text-white font-semibold rounded-lg transition-colors duration-300">
                
                Our Services
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>);

}